import { render, staticRenderFns } from "./purifyoutStorageHistory.vue?vue&type=template&id=3c7d9a82&scoped=true&"
import script from "./purifyoutStorageHistory.vue?vue&type=script&lang=js&"
export * from "./purifyoutStorageHistory.vue?vue&type=script&lang=js&"
import style0 from "./purifyoutStorageHistory.vue?vue&type=style&index=0&id=3c7d9a82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7d9a82",
  null
  
)

export default component.exports